import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import loginReducer from "./login-slice";
import loaderReducer from "./loader-slice";
import alertReducer from "./alert-slice";
import testTimerReducer from "./test-timer-slice";
import planReducer from "./plan-slice";
import checkPlanReducer from "./check-plan-slice";

import { eventApi } from "../tutor/services/schedule-service";
// eslint-disable-next-line import/named
import { SubTutorApi } from "../subtutor/services/schedule-service";
import { zoomApi } from "../tutor/services/zoom-services";
import { zoomSubTutorApi } from "../subtutor/services/zoom-service";
import { subjectQuetionsApi } from "../tutor/services/get_all_questions_by_subject";
import { addQuestionsToTestApi } from "../tutor/services/add_questions_to_test";
import { subjectApi } from "../tutor/services/subjects-by-classes-id";
import { noticeApi } from "../tutor/services/notice-service";
import { noticeSubtutorApi } from "../subtutor/services/notice-service";
import { subjectSubtutorApi } from "../subtutor/services/subjects-by-classes-id";
import { selectPlanApi } from "../tutor/services/selected-plan";
import { studentScheduleApi } from "../student/services/schedule-service";
import { noticeStudentApi } from "../student/services/notice-service";

const store = configureStore({
  reducer: {
    login: loginReducer,
    loader: loaderReducer,
    alert: alertReducer,
    testTimer: testTimerReducer,
    plan: planReducer,
    checkPlan: checkPlanReducer,
    [eventApi.reducerPath]: eventApi.reducer,
    [SubTutorApi.reducerPath]: SubTutorApi.reducer,
    [zoomApi.reducerPath]: zoomApi.reducer,
    [zoomSubTutorApi.reducerPath]: zoomSubTutorApi.reducer,
    [subjectQuetionsApi.reducerPath]: subjectQuetionsApi.reducer,
    [addQuestionsToTestApi.reducerPath]: addQuestionsToTestApi.reducer,
    [noticeApi.reducerPath]: noticeApi.reducer,
    [subjectApi.reducerPath]: subjectApi.reducer,
    [noticeSubtutorApi.reducerPath]: noticeSubtutorApi.reducer,
    [noticeStudentApi.reducerPath]: noticeStudentApi.reducer,
    [subjectSubtutorApi.reducerPath]: subjectSubtutorApi.reducer,
    [studentScheduleApi.reducerPath]: studentScheduleApi.reducer,
    [selectPlanApi.reducerPath]: selectPlanApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(eventApi.middleware)
      .concat(SubTutorApi.middleware)
      .concat(zoomApi.middleware)
      .concat(zoomSubTutorApi.middleware)
      .concat(subjectQuetionsApi.middleware)
      .concat(subjectApi.middleware)
      .concat(subjectSubtutorApi.middleware)
      .concat(noticeApi.middleware)
      .concat(noticeSubtutorApi.middleware)
      .concat(addQuestionsToTestApi.middleware)
      .concat(addQuestionsToTestApi.middleware)
      .concat(studentScheduleApi.middleware)
      .concat(noticeStudentApi.middleware)
      .concat(selectPlanApi.middleware),
});

setupListeners(store.dispatch);

export default store;
